/*
 * @Author: Teemo Ding
 * @Date: 2021-08-12 13:49:26
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-24 17:33:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/CustomerAccount/index.tsx
 */
import { SizeFittingTable } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { customerAccountColumns } from '../config';
import VisibilityToggle from 'src/components/VisibilityToggle';
import css from '../css.module.less';

const CustomerAccount = ({ customer, customerDatabaseUuid }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [showRealName, setShowRealName] = useState(false);
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.informationContainer}  ${css.legalConsentContainer} ${css.wrapperContainer}`}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>
              {getI18n('customerList.customerAccount.customerAccount')}
            </span>
            <VisibilityToggle
              defaultVisible={false}
              onToggle={setShowRealName}
            />
          </div>
        }>
        <SizeFittingTable
          columns={customerAccountColumns(
            customerDatabaseUuid,
            { getI18n },
            showRealName,
          )}
          id='customerAccountTable'
          rowKey='uuid'
          pagination={false}
          dataSource={customer}
        />
      </SectionWrapper>
    </div>
  );
};

export default CustomerAccount;
